import { render } from "./UploadView.vue?vue&type=template&id=3abc24c6"
import script from "./UploadView.vue?vue&type=script&lang=js"
export * from "./UploadView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__